import { useToast } from 'wot-design-uni'
/**
 * 跳转再封装,主要是为了兼容外链。
 * @param {any} path - 跳转路径
 */
function routerTo(path: any) {
  if (path) {
    // 是否跳转外部链接
    if (~path.indexOf('http') || ~path.indexOf('www')) {
      // #ifdef H5
      window.location = path
      // #endif
      // #ifndef  H5
      uni.navigateTo({
        url: `/pages/webview/webview?url=${path}`,
      })
      // #endif
      return false
    }

    const isTabbarPath = [].includes(path)
    if (isTabbarPath) {
      uni.switchTab({
        url: path,
      })
    } else {
      // 路由判断，小程序路由层级限制最大数为8
      const MAX_VALUE = 8
      let pages = getCurrentPages()
      let dlt = ''
      // 查找目标页在页面栈的位置
      for (var i = 0; i < MAX_VALUE; i++) {
        if (pages[i]) {
          if (pages[i].$page && pages[i].$page.fullPath && pages[i].$page.fullPath == path) {
            dlt = i + 1 //目标页在栈中的位置
            break
          }
        }
      }
      // 如果有重复则返回到页面栈页面
      if (dlt) {
        uni.navigateBack({
          delta: pages.length - dlt,
          success: () => {
            const prevPage = pages[pages.length - dlt]
            const { onLoad, options } = prevPage
            // 重新触发页面onLoad
            onLoad && onLoad(options)
          },
        })
      } else {
        if (pages.length < MAX_VALUE) {
          uni.navigateTo({
            url: path,
          })
        } else {
          uni.redirectTo({
            url: path,
          })
        }
      }
    }
  } else {
    console.log(`%cerr:没有填写跳转路径`, 'color:green;background:yellow')
  }
}

/**
 * Toast 轻提示
 * @param text  string
 * @param duration 3000
 */
function toast(text: string, duration = 3000) {
  uni.showToast({
    title: text,
    duration: duration,
    icon: 'none',
  })
}
/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
function handleTree(data: any, id: any, parentId?: any, children?: any) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  }

  const childrenListMap: any = {}
  const nodeIds: any = {}
  const tree = []

  for (const d of data) {
    const parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o: any) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * 复制
 * @param {*} text
 */
function onCopy(text) {
  uni.setClipboardData({
    data: text,
    success: function (data) { },
  })
}

/**
 * @description 生成唯一 uuid
 * @return string
 */
function generateUUID() {
  if (typeof crypto === 'object') {
    if (typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
    if (typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
      const callback = (c) => {
        const num = Number(c)
        return (num ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))).toString(
          16,
        )
      }
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, callback)
    }
  }
  let timestamp = new Date().getTime()
  let performanceNow =
    (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let random = Math.random() * 16
    if (timestamp > 0) {
      random = (timestamp + random) % 16 | 0
      timestamp = Math.floor(timestamp / 16)
    } else {
      random = (performanceNow + random) % 16 | 0
      performanceNow = Math.floor(performanceNow / 16)
    }
    return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
  })
}
/**
 * @description 获取小数位数
 * @param {*} num
 * @return number
 */
function decimals(num) {
  //判断数字是否有小数
  if (String(num).indexOf('.') === -1) {
    return 0
  } else {
    let x = String(num).indexOf('.') + 1 //小数点的位置
    let y = String(num).length - x //小数的位数
    //返回小数点后的个数
    return y
  }
}
// 音频播放处理
const audioPlay = (innerAudioContext, src) => {
  try {
    innerAudioContext = uni.createInnerAudioContext()
    console.log('audioPlay', innerAudioContext, src);

    innerAudioContext.autoplay = true
    innerAudioContext.loop = false;
    innerAudioContext.src = src
    innerAudioContext.onPlay(() => {
      console.log('开始播放')
    })
    innerAudioContext.onError((res) => {
      console.log(res)
      throw new Error("播放失败");

    })
    // if (innerAudioContext) {
    //   innerAudioContext.pause();
    //   innerAudioContext.destroy()
    //   innerAudioContext = null
    // }
  } catch (error) {
    console.log("播放失败", error)
    throw new Error("播放失败");
  }
}
/**
 * 判断是否是当前页面
 * @param url 
 * @returns 
 */
const isCurrentPage = (url) => {
  const currentPage = getCurrentPages()
  const currentPageUrl = currentPage[currentPage.length - 1].route
  // console.log(currentPageUrl, url)
  return currentPageUrl === url
}

export default {
  routerTo,
  toast,
  handleTree,
  onCopy,
  generateUUID,
  decimals,
  audioPlay,
  isCurrentPage
}
